import { RssCard, RssItem } from "../types/rssTypes";

export const rssAdapter = (items: RssItem[]): RssCard[] => {
  return items
    .filter(
      (item) =>
        item.title &&
        item.link &&
        item.valorDaOferta &&
        item.cidadeDeOrigem &&
        item.cidadeDeDestino &&
        item.featuredImage,
    ) // Filtra apenas os itens completos
    .map((item) => ({
      title: item.title!,
      link: item.link,
      price: item.valorDaOferta!,
      averagePrice: item.valorMedio,
      travelDates: item.mesesDeViagem,
      origem: item.cidadeDeOrigem!,
      destino: item.cidadeDeDestino!,
      image: item.featuredImage!,
    }));
};
